import { createApiClient, createHttpClient, createTokenStore, type ApiClient } from '@getpay93/api';
import { API_BASE_URL } from './env';

export const tokenStore = createTokenStore();

/** Última org activa del usuario. Al volver a loguearse se restaura (ver AuthContext). */
export const lastOrgStore = createTokenStore({ key: 'gp.auth.orgId' });

let unauthorizedHandler: (() => void) | null = null;
export function setUnauthorizedHandler(fn: (() => void) | null) {
  unauthorizedHandler = fn;
}

const http = createHttpClient({
  baseUrl: API_BASE_URL,
  getToken: () => tokenStore.get(),
  onUnauthorized: () => unauthorizedHandler?.(),
});

export const api: ApiClient = createApiClient(http, { baseUrl: API_BASE_URL, getToken: () => tokenStore.get() });
